import React from 'react';

export interface PulseCoreIconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
  size?: number | string;
}

/**
 * Pulse Core Symbol
 *
 * Central command / core symbol for the OWNER role:
 * - Circular orb / core housing
 * - Energetic inner pulse / lightning motif
 * - Ultra-crisp readability at 10px, 12px, 14px, and 16px
 * - Pure electric teal / cyan-teal alignment
 */
export const PulseCoreIcon: React.FC<PulseCoreIconProps> = ({
  className = 'w-3 h-3',
  size,
  ...props
}) => {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={size}
      height={size}
      aria-hidden="true"
      {...props}
    >
      {/* Outer circular core / orb boundary */}
      <circle
        cx="8"
        cy="8"
        r="6.75"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        className="opacity-95"
      />
      {/* Ambient core glow halo */}
      <circle
        cx="8"
        cy="8"
        r="4.75"
        fill="currentColor"
        className="opacity-15"
      />
      {/* Inner Pulse / Lightning Core Motif */}
      <path
        d="M8.25 3.2L5.4 7.9H7.9L7.3 12.8L10.6 7.1H8.1L8.25 3.2Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.3"
        strokeLinejoin="round"
      />
    </svg>
  );
};
